module.exports = __webpack_public_path__ + "static/media/silver-bottle-cap.1ed192ba.png";